








import { Component, Mixins } from 'vue-mixin-decorator';
import { Prop } from 'vue-property-decorator';

import DesignPathCreator from '@/components/mixin/DesignPathCreator.vue';

import * as DesignCode from '@/classification/DesignCode';

import RepositoryFactory from '@/repository/RepositoryFactory';

@Component
export default class ExamHeader extends Mixins<DesignPathCreator>(DesignPathCreator) {
  private logoUri = '';

  private logoAltText = '';

  @Prop({ default: '' })
  additionalClass: string;

  private created() {
    try {
      const ExamRepository = RepositoryFactory.get().exam;
      ExamRepository.getExam().then((response: any) => {
        if (response.status === 200 && response.data.resources !== undefined) {
          response.data.resources.forEach((resource: any) => {
            if (resource.display_place_key === DesignCode.TOP_MV_LOGO) {
              this.logoUri = resource.resource_uri;
              this.logoAltText = resource.alternative_text;
            }
          });
        }
      });
    } catch (error) {
      //
    }
  }
}
